import { logg } from '@/util/logg';
import { getColor } from '@/util/player';
import { FieldSchema } from '@lc/schema/FieldSchema';

const rowStyle: React.CSSProperties = {
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
	marginBottom: '6px',
};

const labelStyle: React.CSSProperties = {
	width: '420px',
	fontWeight: 500,
	flexShrink: 0,
};

const fieldStyle: React.CSSProperties = {
	flex: 1,
};

const evenRowBg = 'rgba(255,255,255,0)'; // 0% gray
const oddRowBg = 'rgba(0,0,0,0.15)';

export function FieldRenderer({
	schema,
	value,
	onChange,
	path = '',
	rowIndex = { current: 0 },
}: {
	schema: FieldSchema;
	value: any;
	onChange: (v: any) => void;
	path?: string;
	rowIndex?: { current: number };
}) {
	function getBGColor(obj: any) {
		if (!obj.hasOwnProperty('color')) {
			return '#ffffff';
		}

		logg('getBGColor');
		logg(obj);
		logg(obj.color);

		return getColor(obj['color']);
	}

	switch (schema.type) {
		case 'number':
			return (
				<input
					type="number"
					value={value ?? 0}
					onChange={(e) => onChange(Number(e.target.value))}
				/>
			);

		case 'string':
			return (
				<input
					value={value ?? ''}
					onChange={(e) => onChange(e.target.value)}
				/>
			);

		case 'boolean':
			return (
				<input
					type="checkbox"
					checked={!!value}
					onChange={(e) => onChange(e.target.checked)}
				/>
			);

		case 'number[]':
		case 'string[]':
			return (
				<textarea
					value={(value ?? []).join(',')}
					onChange={(e) =>
						onChange(
							e.target.value
								.split(',')
								.map((v) =>
									schema.type === 'number[]'
										? Number(v.trim())
										: v.trim()
								)
						)
					}
				/>
			);

		case 'object':
			return (
				<div
					style={{
						paddingLeft: 16,
						backgroundColor: getBGColor(value),
					}}
				>
					{Object.entries(schema.fields!).map(([key, field]) => {
						const isOdd = rowIndex.current % 2 === 1;
						const background = isOdd ? oddRowBg : evenRowBg;

						rowIndex.current++;

						return (
							<div
								key={key}
								style={{
									...rowStyle,
									background,
									padding: '4px 6px',
									borderRadius: 4,
								}}
							>
								<label style={labelStyle}>{key}</label>

								<div style={fieldStyle}>
									<FieldRenderer
										schema={field}
										value={value?.[key]}
										onChange={(v) =>
											onChange({ ...value, [key]: v })
										}
										path={`${path}.${key}`}
										rowIndex={rowIndex}
									/>
								</div>
							</div>
						);
					})}
				</div>
			);

		case 'object[]':
			return (
				<div>
					{(value ?? []).map((item: any, i: number) => (
						<div
							key={i}
							style={{ border: '1px solid #444', margin: 8 }}
						>
							<FieldRenderer
								schema={{
									type: 'object',
									fields: schema.fields,
								}}
								value={item}
								onChange={(v) => {
									const copy = [...value];
									copy[i] = v;
									onChange(copy);
								}}
							/>
						</div>
					))}
				</div>
			);
	}
}
